import Constants from '@/Constants';
import { Question } from '@/models/QuestionCreateData';
import { ApplicationState } from '@/store';
import { getQuestionRequest } from '@/store/evaluationQuestion/actions';
import React, { SyntheticEvent } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './style.scss';

interface Props {
    question: Question;
    onDelete: (question: Question) => void;
    setShowQuestionModal: (value: boolean) => void;
}

const QuestionCard: React.FC<Props> = (props: Props) => {
    const { strings, currentCourseInEdition } = useSelector((state: ApplicationState) => ({
        strings: state.locale.data,
        currentCourseInEdition: state.lists.courseData,
    }));

    const dispatch = useDispatch();

    const { question, onDelete, setShowQuestionModal } = props;

    const onEditClickHandler = (e: SyntheticEvent) => {
        e.preventDefault();
        e.stopPropagation();
        setShowQuestionModal(true);
        question.id && dispatch(getQuestionRequest(question.id));
    };

    const onDeleteClickHandler = (e: SyntheticEvent) => {
        e.preventDefault();
        e.stopPropagation();

        onDelete(question);
    };

    return (
        <div className="question-card">
            <span className="question-card__question-description">{question.description.replace(/<[^>]+>/g, '').replace(/&nbsp;/g, ' ')}</span>
            {currentCourseInEdition.status !== Constants.courseStatus.PUBLISHED &&
                <div className="question-card__button-container">
                    <div className="question-card__button-container__delete">
                        <a href="#" onClick={onDeleteClickHandler}>
                            <span className="delete-btn">{strings.DELETE}</span>
                        </a>
                    </div>
                    <div className="question-card__button-container__edit">
                        <button className="btn edit-btn" onClick={onEditClickHandler}>
                            <span className="edit-btn">{strings.EDIT}</span>
                            <i className="material-icons icon edit-icon">{Constants.icons.EDIT}</i>
                        </button>
                    </div>
                </div>
            }
        </div>
    );
};

export default QuestionCard;
